import { WorkflowsGate } from 'app/components/workflows/WorkflowsGate'
import { WorkflowsListPage } from 'app/components/workflows/WorkflowsListPage'

export const handle = {
  title: `Workflows`,
  breadcrumb: `Workflows`,
}

export default function WorkflowsListView() {
  return (
    <WorkflowsGate>
      <WorkflowsListPage />
    </WorkflowsGate>
  )
}
